module.exports = __webpack_public_path__ + "static/img/NE.208e303c.svg";